import "./thumbnail_editor.js";
import "./thumbnail_editor_modal.js";
import "../../shared/components/wizard_modal.js";
import "../form.js";

window.Sparkle ??= {};

Sparkle.PublishingSnippetPreview = class PublishingSnippetPreview {
  constructor(thumbnailData, options) {
    this.render = this.render.bind(this);
    this.renderThumbnail = this.renderThumbnail.bind(this);
    this.renderTitle = this.renderTitle.bind(this);
    this.renderDescription = this.renderDescription.bind(this);
    this._handleThumbnailClicked = this._handleThumbnailClicked.bind(this);
    this._handleDescriptionClicked = this._handleDescriptionClicked.bind(this);
    this._handleThumbnailModalComplete = this._handleThumbnailModalComplete.bind(this);
    this._handleDescriptionModalComplete = this._handleDescriptionModalComplete.bind(this);
    this._resetThumbnailEditor = this._resetThumbnailEditor.bind(this);
    this._triggerUpdate = this._triggerUpdate.bind(this);
    this._triggerEvent = this._triggerEvent.bind(this);
    this.title = options.title;
    this.description = options.description;
    this.thumbnailAspectRatio = options.aspectRatio;
    this.thumbnailData = {
      ...thumbnailData,
    };
    this.editable = options.editable || (() => true);

    this.el = jQuery('<div class="publishing-snippet-preview">');

    this.thumbnailContainer = jQuery('<div class="publishing-snippet-preview-thumbnail-container">');
    this.titleContainer = jQuery('<div class="publishing-snippet-preview-title-container">');
    this.descriptionContainer = jQuery('<div class="publishing-snippet-preview-description-container">');

    this.thumbnailEditor = new ThumbnailEditor(options);

    this.thumbnailModal = new Sparkle.ThumbnailEditorModal(this.thumbnailEditor, "Edit Preview Thumbnail");

    this.descriptionModal = new WizardModal({ class: "admin-modal" });
    const descriptionModalBody = jQuery('<div class="definition-list">').append(
      window.SparkleConfig.adminHtml.publishingSnippetSummaryFields,
    );
    this.descriptionModelTextarea = descriptionModalBody.find("textarea");
    this.descriptionModal.addPage({ header: "Edit Preview Summary", body: descriptionModalBody });

    // BEHAVIOUR

    this.thumbnailContainer.on("click", this._handleThumbnailClicked);
    this.descriptionContainer.on("click", this._handleDescriptionClicked);
    jQuery(this.thumbnailModal).on("complete", this._handleThumbnailModalComplete);
    jQuery(this.descriptionModal).on("complete", this._handleDescriptionModalComplete);
    jQuery(this.thumbnailModal).on("cancel", this._resetThumbnailEditor);
  }

  render() {
    this.renderTitle();
    this.renderDescription();
    this.renderThumbnail();

    if (this.title !== false) {
      this.el.append(this.titleContainer);
    }
    this.el.append(this.thumbnailContainer);
    if (this.description !== false) {
      this.el.append(this.descriptionContainer);
    }

    return this;
  }

  renderThumbnail() {
    return this._resetThumbnailEditor().then(() => {
      let src;
      if (this.thumbnailEditor.hasImage()) {
        src = this.thumbnailEditor.getPreviewUrl();
      } else {
        src = window.SparkleConfig.assetPaths.imageEmptyPlaceholder;
      }

      const thumbnail = jQuery("<img>", { class: "publishing-snippet-preview-thumbnail", src });

      if (this.thumbnailAspectRatio) {
        thumbnail.css("aspect-ratio", String(this.thumbnailAspectRatio));
      }

      return this.thumbnailContainer.html(thumbnail);
    });
  }

  renderTitle() {
    return this.titleContainer.text(this.title);
  }

  renderDescription() {
    return this.descriptionContainer.text(this.description);
  }

  // EVENT HANDLERS

  _handleThumbnailClicked() {
    if (!this.editable()) {
      return;
    }

    return this.thumbnailModal.show();
  }

  _handleDescriptionClicked() {
    this.descriptionModelTextarea.val(this.description);
    Form.decorate(this.descriptionModal.body);
    return this.descriptionModal.show();
  }

  _handleThumbnailModalComplete() {
    this.thumbnailData = this.thumbnailEditor.getThumbnail();
    this.renderThumbnail();
    this._triggerEvent("update:thumbnail", this.thumbnailData);
    return this._triggerUpdate();
  }

  _handleDescriptionModalComplete() {
    this.description = this.descriptionModelTextarea.val();
    this.renderDescription();
    this._triggerEvent("update:description", this.description);
    return this._triggerUpdate();
  }

  // HELPER FUNCTIONS

  _resetThumbnailEditor() {
    return this.thumbnailEditor.setThumbnail(this.thumbnailData);
  }

  _triggerUpdate() {
    return this._triggerEvent("update", { description: this.description, thumbnailData: this.thumbnailData });
  }

  _triggerEvent(name, ...payload) {
    return jQuery(this).triggerHandler(name, payload);
  }
};
